import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Component } from "react";
import "@/App.css";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Faq from "@/pages/Faq";
import Services from "@/pages/Services";
import TaxServices from "@/pages/TaxServices";
import Pricing from "@/pages/Pricing";
import Industries from "@/pages/Industries";
import OurStory from "@/pages/OurStory";
import Contact from "@/pages/Contact";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-cream px-6">
          <div className="text-center">
            <p className="font-serif text-3xl text-pine">Something went wrong.</p>
            <p className="mt-2 text-stone2">Please refresh the page.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-pine/60">404</p>
      <h1 className="mt-4 font-serif text-5xl text-ink">Page not found</h1>
      <a data-testid="notfound-home-link" href="/" className="mt-8 inline-flex items-center rounded-md bg-pine px-6 py-3 text-sm font-semibold text-cream hover:bg-gold hover:text-ink transition-colors">
        Back to home
      </a>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <SmoothScroll />
        <ScrollToTop />
        <Seo />
        <div className="grain min-h-screen bg-cream text-ink antialiased">
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/tax-services" element={<TaxServices />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/our-story" element={<OurStory />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="bottom-right" />
        </div>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
